export default "__VITE_ASSET__CqSUVtWQ__"